import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { connect } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import { Table } from 'ui/atoms';

// eslint-disable-next-line import/no-cycle
import { CrudLayout, MultiDropdown } from '..';
import { columnsRfid } from './columnsRfid';
import { FiltersContainer, RfidCardMainContainer, RfidHeader } from './style';

const RfidCard = ({ rfid, details }) => {
  const [list, setList] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    setList(rfid);
  }, [rfid]);

  useEffect(() => {
    setUsers(
      [details?.userId, ...(details?.secondaryUsers || [])].map(v => ({
        label: v,
        value: v
      }))
    );
  }, [details]);

  const fetchAccountsByPage = filters => {
    if (filters && Object.keys(filters).length && filters.userID) {
      const filteredUsers = filters.userID.map(v => v.value);
      setList(rfid.filter(r => filteredUsers.includes(r.userId)));
    } else {
      setList(rfid);
    }
  };

  return (
    <RfidCardMainContainer>
      <RfidHeader>
        <FiltersContainer>
          <MultiDropdown
            dropdownList={[
              {
                options: users,
                placeholder: 'User ID',
                menuWidth: 178,
                isMulti: true,
                checkBoxMenu: true,
                isClearable: false,
                detachedOptions: true,
                name: 'userID',
                resetSelection: true
              }
            ]}
            height="72px"
            width="297px"
            onSubmit={fetchAccountsByPage}
            maxWidthControls="188px"
          />
        </FiltersContainer>
      </RfidHeader>
      {rfid?.length > 0 && (
        <CrudLayout>
          <Table headerColumns={columnsRfid} data={list} />
        </CrudLayout>
      )}
    </RfidCardMainContainer>
  );
};

RfidCard.propTypes = {
  rfid: PropTypes.array,
  details: PropTypes.object
};

export default connect(state => ({
  rfid: state?.cpDetails.rfid,
  details: state.cpDetails?.details
}))(RfidCard);
